import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "services/api.service";
import { OnboardingStage } from "types/onboarding";

export const OnboardingContext = createContext<{
  fetchOnboarding: () => void;
  isLoading: boolean;
  onboarding: OnboardingStage[];
}>({
  fetchOnboarding: () => {},
  isLoading: true,
  onboarding: [],
});

export const OnboardingProvider = ({ children }: { children: React.ReactNode }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [onboarding, setOnboarding] = useState<OnboardingStage[]>([]);

  const fetchOnboarding = useCallback(async () => {
    setIsLoading(true);
    await api
      .get("/onboarding")
      .then(({ data }) => {
        // Convert object to array - API returns object with numeric keys instead of array
        const onboardingArray = Array.isArray(data) ? data : Object.values(data);
        setOnboarding(onboardingArray as OnboardingStage[]);
      })
      .catch(() => setOnboarding([]))
      .finally(() => setIsLoading(false));
  }, []);

  useEffect(() => {
    fetchOnboarding();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <OnboardingContext.Provider value={{ fetchOnboarding, isLoading, onboarding }}>
      {children}
    </OnboardingContext.Provider>
  );
};

export default function useOnboarding() {
  return useContext(OnboardingContext);
}
